import React from 'react'
import { i18n } from '@fs/zion-locale'
import { Usabilla } from '@fs/zion-usabilla'

const localeMap = {
  en: '',
  de: 'German',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  ja: 'Japanese',
  pt: 'Portuguese',
  ru: 'Russian',
  zh: 'ChineseTraditional',
  cs: 'Czech',
  da: 'Danish',
  el: 'Greek',
  et: 'Estonian',
  hu: 'Hungarian',
  nl: 'Dutch',
  no: 'Norwegian',
  pl: 'Polish',
  ro: 'Romanian',
  sr: 'Serbian',
  sv: 'Swedish',
}

export default function SitesUsabilla() {
  const languageIsSupported = Object.keys(localeMap).includes(i18n.language)

  return (
    <>{languageIsSupported && <Usabilla url="//w.usabilla.com/13d458874af1.js" hideOnMobile localeMap={localeMap} />}</>
  )
}
